import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Badge, Button, Col, Label, Row } from "reactstrap"
import { formatCurrency } from "../../../utils/formatCurrency"
import { deleteInternalPayslipe, getAllInternalPayslips } from "../../../api/internalPayslips"
import { PERMISSIONS } from "../../../api/permissions";
import TableAction from "../../../components/TableAction"
import DeleteModal from "../../../components/Common/DeleteModal"
import { useResponse } from "../../../hooks/useResponse"
import moment from "moment"
import SendPayslipesMailModal from "./SendPayslipesMailModal"
import TableFilter from "../../../components/TableFilter"

export default function InternalPayslipesTable() {
  const { t } = useTranslation()
  const navigate = useHistory()
  
  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getAllInternalPayslips)

  // delete 
  const [show, setShow] = useState(false)
  const [deletingPayslipe, setDeletingPayslipe] = useState(null)

  const { setData } = useResponse(deleteInternalPayslipe, () => {
    setShow(false)
    setDeletingPayslipe(null)
    setPayload({ref: true})
  })

  function onDeleteClick() {
    setData({ type: "delete", data: deletingPayslipe })
  }

  function onCloseClick() {
    setShow(false)
  }

  // Filters
  const filterTypes = [
    {key: "admin", type: "text"}
  ]

  // select => send email
  const [isEmailModelOpen, setIsEmailModelOpen] = useState(false)
  const [selectedMailPayslipes, setSelectedMailPayslipes] = useState([])
  const handleSelectedIds = (payslip) => {
    if(selectedMailPayslipes.map(p => p.id).includes(payslip.id)) {
      setSelectedMailPayslipes(prev => prev.filter(p => p.id !== payslip.id))
    } else {
      setSelectedMailPayslipes(prev => [...prev, payslip])
    }
  }
  
  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.INTERNAL_PAYSLIPE_CREATE}
        addUrl="/add-internal-payslipe"
        setPage={setPage}
        setPerPage={setPerPage}
      />

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: filters })}
      />

      {selectedMailPayslipes.length > 0 && <div className="d-flex gap-2 mb-3">
        <Badge color="dark" className="d-flex" style={{fontSize: "16px", alignItems: "center"}}>
          {selectedMailPayslipes.length} selected 
          <span style={{opacity: "0.5", margin: "0px 6px"}}>|</span> 
          <i style={{cursor: "pointer"}} className="mdi mdi-close" onClick={() => setSelectedMailPayslipes([])}></i>
        </Badge>

        <Button color="dark" className="me-3 fw-bold" onClick={() => setIsEmailModelOpen(true)}>
            Send Via Email
        </Button>
      </div>}

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{width: "3%"}}></Th>
                <Th>Admin</Th>
                <Th>Date</Th>
                <Th>Price</Th>
                <Th style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.internalPayslips.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td className="text-center">
                        <input 
                          type="checkbox"
                          style={{cursor: 'pointer'}}
                          onChange={() => handleSelectedIds(row)} 
                          checked={selectedMailPayslipes.map(payslip => payslip.id).includes(row.id)}
                        />
                      </Td>
                      <Td>{row.admin.username}</Td>
                      <Td>{moment(row.date).format("DD MMM YYYY")}</Td>
                      <Td>{formatCurrency(row.price)}</Td>
                      <Td>
                        <TableAction
                          hasDelete={true}
                          deletePermission={PERMISSIONS.INTERNAL_PAYSLIPE_DELETE}
                          type="internal-payslipe"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingPayslipe}
                        />
                         <Button onClick={() => navigate.push('/internal-payslipe-details/'+row.id, {payslipe: row})} style={{marginLeft: "5px"}} color="dark">
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.internalPayslips.length === 0} msg="No Internal Payslipes Found." />
          }

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          <SendPayslipesMailModal 
            isOpen={isEmailModelOpen}
            handleClose={() => setIsEmailModelOpen(false)}
            payslipes={selectedMailPayslipes}
            onSucess={() => setSelectedMailPayslipes([])}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
